import axios from "axios";

export const axiosAPI = axios.create({
  withCredentials: false,
  baseURL: process.env.NEXT_PUBLIC_API,
  headers: {
    ["Accept"]: "application/json",
    ["Content-Type"]: "application/json",
    ["Access-Control-Allow-Origin"]: "*",
    ["Mode"]: "no-cors",
    ["Access-Control-Allow-Methods"]: "*",
  },
});
